export default "__VITE_ASSET__3d818880__"